import { Box, Divider, Grid, IconButton, Paper, Typography, makeStyles } from '@material-ui/core';
import { AlternateEmail, ArrowRight, Sms, WhatsApp } from '@material-ui/icons';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import React, { useContext } from 'react';
import { AcompanharReguaCobrancaContext } from '../AcompanharReguaCobrancaContext';
import { AcompanharReguaCobrancaModais } from './Modal/AcompanharReguaCobrancaModais';

const useStyles = makeStyles({
  icons: {
    backgroundColor: '#5c93aa',
    color: '#fff',
    width: '20px',
    height: '20px',
    padding: '5px',
    marginRight: '5px',
    borderRadius: '25px',
  },
  iconButton: {
    backgroundColor: '#f3f3f3',
    borderRadius: '15px',
    marginRight: 5,
    width: '100px',
    height: '31px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  responsive: {
    display: 'flex',
    flexGrow: 1,
    height: 'calc(100vh - 201px)',
    '@media screen and (max-width: 1279px)': {
      height: 'calc(100vh - 146px)',
    },
    '@media only screen and (max-width: 978px)': {
      height: 'calc(100vh - 175px)',
    },
  },
});

const AcompanharTimeLine = ({ card }) => {
  const styles = useStyles();
  const [, setModal] = useContext(AcompanharReguaCobrancaContext).modal;
  const [, setCardAtual] = useContext(AcompanharReguaCobrancaContext).cardAtual;

  const TIPO_PASSO_APOS = 'COBRANCA_APOS_VENCIMENTO';
  const TIPO_PASSO_ANTES = 'LEMBRETE_VENCIMENTO';

  const cardsApos = card.filter((card) => card?.tipoPasso === TIPO_PASSO_APOS);
  const cardsAntes = card.filter((card) => card?.tipoPasso === TIPO_PASSO_ANTES);

  const handleVisualizarCobranca = (card) => {
    setCardAtual(card);
    setModal(AcompanharReguaCobrancaModais.visualizarCobranca);
  };

  const renderTimelineItem = (card, color) => (
    <TimelineItem style={{ marginLeft: '-400px' }}>
      <TimelineSeparator>
        <TimelineConnector />
        <TimelineDot
          style={{
            backgroundColor: color,
            marginTop: '50%',
          }}
        />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <Paper elevation={3} style={{ borderRadius: '12px', padding: '10px' }}>
          <Grid container>
            <Grid item xs={8}>
              <Typography
                style={{
                  fontSize: '16px',
                  color: '#000',
                  marginBottom: '15px',
                  marginRight: '10px',
                }}
              >
                {`${card?.dias} dias ${card?.tipoPasso === TIPO_PASSO_APOS ? 'após o' : 'antes do'} vencimento`}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <IconButton
                onClick={() => handleVisualizarCobranca(card)}
                style={{
                  borderRadius: '5px',
                  fontSize: '12px',
                  color: '#c9c9c9',
                  marginBottom: '15px',
                  padding: '0px',
                }}
              >
                {`${card?.contasReceber?.length || 0} cobranças enviadas`}
                <ArrowRight />
              </IconButton>
            </Grid>

            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
              {card?.acoes?.map((acao, index) => {
                let icon = null;
                let label = '';

                switch (acao) {
                  case 'EMAIL':
                    icon = <AlternateEmail className={styles.icons} />;
                    label = 'E-mail';
                    break;
                  case 'SMS':
                    icon = <Sms className={styles.icons} />;
                    label = 'SMS';
                    break;
                  case 'WHATSAPP':
                    icon = <WhatsApp className={styles.icons} />;
                    label = 'Whatsapp';
                    break;

                  default:
                    break;
                }

                if (icon) {
                  return (
                    <IconButton key={index} className={styles.iconButton}>
                      {icon}
                      <span style={{ fontSize: '12px' }}>{label}</span>
                    </IconButton>
                  );
                }
                return null;
              })}
            </Grid>
          </Grid>
        </Paper>
      </TimelineContent>
    </TimelineItem>
  );

  const renderTimeline = (cards, color) => {
    return (
      <Timeline>
        {cards?.map((card, index) => (
          <div key={index}>{renderTimelineItem(card, color)}</div>
        ))}
      </Timeline>
    );
  };

  return (
    <>
      {cardsApos.length === 0 && cardsAntes.length === 0 ? (
        <Grid container>
          <Box
            display="flex"
            style={{
              paddingTop: 50,
              fontSize: 17,
              color: 'rgba(0, 0, 0, 0.87)',
              height: '100%',
            }}
            className={styles.responsive}
            alignItems="start"
            justifyContent="center"
          >
            Nenhum registro foi encontrado
          </Box>
        </Grid>
      ) : (
        <>
          {cardsApos.length !== 0 && (
            <Grid container alignItems="center" justify="center" className="stepAposVencimento">
              <Grid item xs={3}>
                <Typography variant="h6" style={{ color: '#717171' }}>
                  Após o vencimento
                </Typography>
              </Grid>
              <Grid item xs={5}>
                {renderTimeline(cardsApos, '#ed9a53')}
              </Grid>
            </Grid>
          )}

          {cardsApos.length !== 0 && cardsAntes.length !== 0 && <Divider style={{ width: '100%', margin: '20px 0' }} />}

          {cardsAntes.length !== 0 && (
            <Grid container alignItems="center" justify="center" className="stepAntesVencimento">
              <Grid item xs={3}>
                <Typography variant="h6" style={{ color: '#717171' }}>
                  Antes do vencimento
                </Typography>
              </Grid>

              <Grid item xs={5}>
                {renderTimeline(cardsAntes, 'green')}
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default AcompanharTimeLine;
